module.exports = __webpack_public_path__ + "dadb021a4815a7af4d934360bc3371eb.svg";